module.exports = __webpack_public_path__ + "static/media/creditcardoffers.lk.e142aed6.svg";